/* Landing comedor — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'comedor'). */


(function(){
  /* ---- Precios (Danny 2026-10-20): 4, 6 u 8 sillas, todas con la puerta GRATIS (se quitó el de 12).
     Productos de Shopify: juego de 4 (129.900), juego de 6 (159.900, Dropi 2296349, Shopify 8810260136097) y puerta (79.900).
     El total sale de descuentos automáticos:
     4+puerta y 6+puerta 'Combo especial (−59.900, subtotal ≥ 209.800)' = 149.900 / 179.900 · 8+puerta 'Combo 3 unidades (−109.800)' = 229.900.
     Los juegos de 4 y de 6 ya están a su precio de diciembre: no llevan tachado. ---- */
  var TEMPORADA_FIN=new Date('2026-12-01T00:00:00-05:00');   // hasta el 30 nov 23:59 Bogotá
  var LIMITE_24=new Date('2026-12-16T00:00:00-05:00');        // pedidos hasta el 15 dic
  var PRECIOS={
    temporada:{4:149900,6:179900,8:229900},
    diciembre:{4:149900,6:179900,8:269900}
  };
  var esDic=Date.now()>=TEMPORADA_FIN.getTime();
  var P=esDic?PRECIOS.diciembre:PRECIOS.temporada;
  var WAS=esDic?null:PRECIOS.diciembre;   // tachado honesto: el precio regular desde el 1 dic
  // clave = número de sillas. j = juegos (diseños que se pueden escoger), prod = producto de Shopify (ver SHOP)
  var TIER={4:{j:1,prod:'sillas'},6:{j:1,prod:'seis'},8:{j:2,prod:'sillas'}};
  function nJ(q){return (TIER[q]||TIER[8]).j}

  /* ---- Diseños: v = variante del juego de 4 (Dropi 2295051), v6 = variante del juego de 6 (Dropi 2296349), p = variante de la funda de puerta (1979374). Texto EXACTO de Shopify/Dropi. ---- */
  var D=[
    {k:'chimenea',a:'01-hero',n:'Chimenea',t:'Papá Noel junto al fuego. Cálido y clásico, para la familia de siempre.',v:'4 CHIMENEA',v6:'6 CHIMENEA',p:'CHIMENEA'},
    {k:'bienvenido',a:'04-despues',n:'Bienvenido',t:'Papá Noel abriendo la puerta. El que recibe a todos.',v:'4 BIENVENIDO',v6:'6 BIENVENIDO',p:'BIENVENIDO'},
    {k:'pesebre',a:'08-novena',n:'Pesebre',t:'La Sagrada Familia bajo la estrella. Para la mesa de la novena.',v:'4 PESEBRE ESTRELLA GRANDE',v6:'6 PESEBRE ESTRELLA GRANDE',p:'PESEBRE ESTRELLA GRANDE'},
    {k:'angel',a:'13-mesa-angel',n:'Ángel',t:'Una angelita que cuida tu mesa. Tierno y luminoso.',v:'4 ANGEL',v6:'6 ANGEL',p:'ANGEL'},
    {k:'papa-mama-noel',a:'02-lifestyle',n:'Papá y Mamá Noel',t:'Los viejitos abrazados con su reno. El favorito de los abuelos.',v:'4 PAPA Y MAMA NOEL (VIEJITOS)',v6:'6 PAPA Y MAMA NOEL VIEJITOS',p:'PAPA Y MAMA NOEL'},
    {k:'merry-christmas',a:'15-merry-moderno',n:'Merry Christmas',t:'Muñeco de nieve y Papá Noel con un corazón de luces.',v:'4 MERRY CHRISTMAS',v6:'6 MERRY CHRITSMAS CORAZON',p:'MERRY CHRITSMAS CORAZON'},
    {k:'copo-nieve',a:'06-cocina',n:'Copo de Nieve',t:'El muñeco de nieve de gorro rojo. El favorito de los niños.',v:'4 COPO DE NIEVE BUFANDA ROJA',v6:'6 COPO DE NIEVE BUFANDA ROJA',p:'COPO DE NIEVE BUFANDA ROJA'},
    {k:'bambi',a:'11-ninos',n:'Bambi',t:'El reno bebé de bufanda roja sobre rojo Navidad. Moderno y alegre.',v:'4 BAMBI BUFANDA ROJA',v6:'6 BAMBI BUFANDA ROJA',p:'BAMBI BUFANDA ROJA'}
  ];
  /* ---- PEDIDO (Plan B, ajustado por Danny 2026-10-13): sillas y puerta son 2 productos de Shopify (2 IDs de Dropi).
     El formulario de Releasit se abre AQUÍ, en la landing (nada de /cart): se arma el carrito interno de
     Releasit (_rsiV2.cartService = Storefront API) con las líneas exactas, se pone su addMode en
     'product-plus-cart' SOLO en esta página (para que no agregue además el diseño por defecto) y se abre con
     su estado + triggerCartUpdate. Precios en vivo 2026-10-20: 4 + puerta 149.900 · 6 + puerta 179.900 · 8 + puerta 229.900.
     OJO: _rsiV2 es la API interna de Releasit; si una actualización la rompe, cae al aviso de reintentar
     (si falla, aviso de reintentar: sin la puerta no se cobra). ---- */
  var SHOP={sillas:'el-comedor-del-24',seis:'combo-6-funda-navidena-para-silla',puerta:'la-puerta-del-24'};   // seis = juego de 6 (Dropi 2296349)   // puerta = producto de la landing hermana "La Puerta del 24" (proyecto funda-navidena-para-puerta)
  function shopCfg(){return window.__COMEDOR_SHOP||SHOP}           // FASE 5 puede inyectarlo desde Liquid sin tocar este archivo
  var sel=D[0], qty=8;
  var juegos=[D[0].k,D[0].k,D[0].k], puertaK=null, mixOpen=-1;   // diseño de cada juego de 4 (se pueden mezclar en 8) y de la puerta
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var fmt=function(n){return '$'+Math.round(n).toLocaleString('es-CO')};
  var A=function(p){return window.__A?window.__A(p):p};   // en Shopify los assets viven planos: __A lo define la section
  var _ASSETS_USADOS=[__A('ad-assets/01-hero.jpg'),__A('ad-assets/02-lifestyle.jpg'),__A('ad-assets/03-antes.jpg'),__A('ad-assets/04-despues.jpg'),__A('ad-assets/05-puerta-mesa.jpg'),__A('ad-assets/06-cocina.jpg'),__A('ad-assets/07-negocio.jpg'),__A('ad-assets/08-novena.jpg'),__A('ad-assets/09-detalle.jpg'),__A('ad-assets/10-bundle.jpg'),__A('ad-assets/11-ninos.jpg'),__A('ad-assets/12-gato.jpg'),__A('ad-assets/13-mesa-angel.jpg'),__A('ad-assets/15-merry-moderno.jpg'),__A('ad-assets/16-foto-familia.jpg'),__A('ad-assets/17-colocando.jpg'),__A('ad-assets/disenos/angel-frente.jpg'),__A('ad-assets/disenos/angel-respaldo.jpg'),__A('ad-assets/disenos/bambi-frente.jpg'),__A('ad-assets/disenos/bambi-respaldo.jpg'),__A('ad-assets/disenos/bienvenido-frente.jpg'),__A('ad-assets/disenos/bienvenido-respaldo.jpg'),__A('ad-assets/disenos/chimenea-frente.jpg'),__A('ad-assets/disenos/chimenea-respaldo.jpg'),__A('ad-assets/disenos/copo-nieve-frente.jpg'),__A('ad-assets/disenos/copo-nieve-respaldo.jpg'),__A('ad-assets/disenos/merry-christmas-frente.jpg'),__A('ad-assets/disenos/merry-christmas-respaldo.jpg'),__A('ad-assets/disenos/papa-mama-noel-frente.jpg'),__A('ad-assets/disenos/papa-mama-noel-respaldo.jpg'),__A('ad-assets/disenos/pesebre-frente.jpg'),__A('ad-assets/disenos/pesebre-respaldo.jpg'),__A('ad-assets/puerta/angel.jpg'),__A('ad-assets/puerta/bambi.jpg'),__A('ad-assets/puerta/bienvenido-alt.jpg'),__A('ad-assets/puerta/bienvenido.jpg'),__A('ad-assets/puerta/chimenea.jpg'),__A('ad-assets/puerta/copo-nieve.jpg'),__A('ad-assets/puerta/merry-christmas.jpg'),__A('ad-assets/puerta/papa-mama-noel.jpg'),__A('ad-assets/puerta/pesebre.jpg'),__A('ad-assets/regalo-cuidado.svg'),__A('ad-assets/regalo-mesa-del-24.svg'),__A('ad-assets/regalo-novena.svg')];   // para que el publicador copie las fotos que el JS arma por partes
  var img=function(k,c){return A('ad-assets/disenos/'+k+'-'+c+'.jpg')};
  var door=function(k){return A('ad-assets/puerta/'+k+'.jpg')};
  var ambi=function(d){return A('ad-assets/'+d.a+'.jpg')};
  var fb=function(el,src){el.onerror=function(){el.onerror=null;el.src=src}};

  /* precios en la página */
  $$('[data-price]').forEach(function(e){e.textContent=fmt(P[e.dataset.price])});
  var tachado=function(q){return WAS&&WAS[q]>P[q]?WAS[q]:0};   // sin tachado si no hay rebaja real
  $$('[data-was]').forEach(function(e){var w=tachado(e.dataset.was);if(w){e.textContent=fmt(w)}else{e.remove()}});
  $$('[data-save]').forEach(function(e){var k=+e.dataset.save;e.textContent='Ahorras '+fmt(P[4]*k/4-P[k])});   // contra comprar juegos de 4 sueltos
  $$('[data-unit]').forEach(function(e){e.textContent=fmt(P[e.dataset.unit]/e.dataset.unit)});
  if(esDic){
    $('#cd-topbar').innerHTML='🎄 Pide antes del <b>15 de diciembre</b> y llega antes del 24 · 💵 Pagas al recibir';
    $$('[data-season-txt]').forEach(function(e){e.textContent='antes del 15 de diciembre'});
    $('#cd-count-l').textContent='Pedidos con entrega antes del 24 cierran en';
  }

  /* chips de diseño */
  var chips=$('#cd-chips');
  D.forEach(function(d,i){
    var b=document.createElement('button');b.type='button';b.className='cd-chip'+(i===0?' on':'');b.dataset.k=d.k;
    b.innerHTML='<img src="'+img(d.k,'frente')+'" alt="" loading="lazy">'+d.n;
    b.onclick=function(){pick(d.k)};chips.appendChild(b);
  });

  /* galería */
  function renderThumbs(){
    var list=sel.k==='chimenea'
      ?[[__A('ad-assets/01-hero.jpg'),'El comedor del 24'],[img(sel.k,'frente'),'Frente y asiento'],[img(sel.k,'respaldo'),'Espalda'],[door(sel.k),'Puerta gemela'],[__A('ad-assets/16-foto-familia.jpg'),'La foto del 24']]
      :[[img(sel.k,'frente'),'Frente y asiento'],[ambi(sel),'Puesta en un comedor'],[img(sel.k,'respaldo'),'Espalda'],[door(sel.k),'Puerta gemela'],[__A('ad-assets/01-hero.jpg'),'El comedor del 24 (Chimenea)']];
    var t=$('#cd-thumbs');t.innerHTML='';
    list.forEach(function(it,i){
      var b=document.createElement('button');b.type='button';b.className=i===0?'on':'';b.setAttribute('aria-label',it[1]);
      b.innerHTML='<img src="'+it[0]+'" alt="" loading="lazy">';fb(b.querySelector('img'),img(sel.k,'frente'));
      b.onclick=function(){$$('#cd-thumbs button').forEach(function(x){x.classList.remove('on')});b.classList.add('on');setMain(it[0])};
      t.appendChild(b);
    });
    setMain(list[0][0]);
  }
  function setMain(src){var m=$('#cd-main');m.style.opacity=0;setTimeout(function(){m.src=src;m.style.opacity=1},120)}

  function pick(k,scroll,soloJuego1){
    sel=D.filter(function(d){return d.k===k})[0]||D[0];
    if(!soloJuego1){juegos=[sel.k,sel.k,sel.k];puertaK=null;mixOpen=-1}else{juegos[0]=sel.k}
    $$('.cd-chip').forEach(function(c){c.classList.toggle('on',c.dataset.k===k)});
    $('#cd-dname').textContent=sel.n;$('#cd-tagname').textContent=sel.n;$('#cd-st-name').textContent=sel.n;
    $$('[data-dimg]').forEach(function(e){e.src=img(sel.k,e.dataset.dimg)});
    $$('[data-dsrc]').forEach(function(e){e.src=img(sel.k,e.dataset.dsrc)});
    $$('[data-door]').forEach(function(e){e.src=door(sel.k)});
    $('#cd-door-img').src=door(sel.k);
    $('#cd-st-img').src=img(sel.k,'frente');$('#cd-st-door').src=door(sel.k);
    renderThumbs();
    actualizarCombo();
    if(scroll){$('#cd-buy').scrollIntoView({behavior:'smooth',block:'start'})}
  }

  /* combos */
  function setQty(q){
    qty=q;
    $$('.cd-bundle').forEach(function(b){b.classList.toggle('on',+b.dataset.qty===q)});
    $('#cd-st-qty').textContent=q+' sillas';
    $('#cd-st-price').textContent=fmt(P[q]);$('#cd-st-was').textContent=tachado(q)?fmt(tachado(q)):'';
    actualizarCombo();
  }
  $$('.cd-bundle').forEach(function(b){b.onclick=function(){setQty(+b.dataset.qty)}});

  /* mezcla de diseños (pedido de Danny 2026-10-13): en 8 cada juego de 4 puede ser de un diseño distinto,
     y la puerta de regalo se escoge entre los diseños del combo. El pedido va a Releasit con una línea por diseño. */
  function dByK(k){return D.filter(function(d){return d.k===k})[0]||D[0]}
  function combo(){return juegos.slice(0,nJ(qty))}
  function unicos(){var u=[];combo().forEach(function(k){if(u.indexOf(k)<0)u.push(k)});return u}
  function puertaKey(){var u=unicos();return puertaK&&u.indexOf(puertaK)>=0?puertaK:u[0]}
  function nombreCombo(){return unicos().map(function(k){return dByK(k).n}).join(' + ')}
  function renderMix(){
    var box=$('#cd-mix');if(!box)return;
    box.hidden=nJ(qty)<2;if(nJ(qty)<2)return;
    var h='',u=unicos(),pk=puertaKey();
    combo().forEach(function(k,i){
      h+='<div class="cd-mix-row'+(mixOpen===i?' open':'')+'" data-i="'+i+'"><button type="button" class="cd-mix-cur"><img src="'+img(k,'frente')+'" alt=""><span><small>Juego '+(i+1)+' · 4 sillas</small><b>'+dByK(k).n+'</b></span><em>'+(mixOpen===i?'Listo ▴':'Cambiar ▾')+'</em></button>'+
        '<div class="cd-mix-opts">'+D.map(function(o){return '<button type="button" class="cd-mix-opt'+(o.k===k?' on':'')+'" data-k="'+o.k+'"><img src="'+img(o.k,'frente')+'" alt="" loading="lazy">'+o.n+'</button>'}).join('')+'</div></div>';
    });
    h+='<div class="cd-mix-row door'+(u.length<2?' fija':'')+(mixOpen==='p'?' open':'')+'" data-i="p"><button type="button" class="cd-mix-cur"><img src="'+door(pk)+'" alt=""><span><small>🎁 Funda de puerta GRATIS</small><b>'+dByK(pk).n+'</b></span><em>'+(u.length<2?'Mismo diseño':(mixOpen==='p'?'Listo ▴':'Cambiar ▾'))+'</em></button>'+
      (u.length>1?'<div class="cd-mix-opts">'+u.map(function(k){return '<button type="button" class="cd-mix-opt'+(k===pk?' on':'')+'" data-k="'+k+'"><img src="'+door(k)+'" alt="">'+dByK(k).n+'</button>'}).join('')+'</div>':'')+'</div>';
    $('#cd-mix-rows').innerHTML=h;
  }
  function actualizarCombo(){
    renderMix();
    var nom=nJ(qty)>=2?nombreCombo():sel.n, pk=puertaKey();
    var nu=nJ(qty)>=2?unicos().length:1;
    $('#cd-dname').textContent=nom;$('#cd-st-name').textContent=nu>1?nu+' diseños':nom;   // en la barra no cabe la lista
    $('#cd-door-img').src=door(pk);$('#cd-st-door').src=door(pk);
  }
  $('#cd-mix-rows').addEventListener('click',function(e){
    var row=e.target.closest('.cd-mix-row');if(!row)return;
    var key=row.dataset.i==='p'?'p':+row.dataset.i, opt=e.target.closest('.cd-mix-opt');
    if(opt){
      if(key==='p')puertaK=opt.dataset.k;
      else{juegos[key]=opt.dataset.k;if(key===0){mixOpen=-1;pick(opt.dataset.k,false,true);return}}
      mixOpen=-1;actualizarCombo();return;
    }
    if(e.target.closest('.cd-mix-cur')&&!(key==='p'&&unicos().length<2)){mixOpen=mixOpen===key?-1:key;renderMix()}
  });

  /* tarjetas de diseños */
  var grid=$('#cd-designs');
  D.forEach(function(d){
    var c=document.createElement('div');c.className='cd-dcard';
    c.innerHTML='<div class="cd-dimg"><img src="'+img(d.k,'frente')+'" alt="Funda '+d.n+' frente" loading="lazy"><img class="b" src="'+img(d.k,'respaldo')+'" alt="Funda '+d.n+' espalda" loading="lazy"><img class="c" src="'+ambi(d)+'" alt="Funda '+d.n+' puesta en un comedor" loading="lazy"><em>↻ ver espalda</em></div>'+
      '<div class="cd-dinfo"><h3>'+d.n+'</h3><p>'+d.t+'</p><span class="cd-dtwin"><img src="'+door(d.k)+'" alt="" loading="lazy">+ su puerta gemela</span><button type="button" class="cd-dbtn">Elegir '+d.n+'</button></div>';
    var box=c.querySelector('.cd-dimg');
    fb(box.querySelector('img.c'),img(d.k,'frente'));
    var st=0,lab=['↻ ver espalda','↻ ver en un comedor','↻ ver frente'];
    box.onclick=function(){st=(st+1)%3;box.classList.toggle('flip',st===1);box.classList.toggle('amb',st===2);box.querySelector('em').textContent=lab[st]};
    c.querySelector('.cd-dbtn').onclick=function(){pick(d.k,true)};
    grid.appendChild(c);
  });

  /* ---- CONTRATO SHOPIFY: un solo punto de compra ---- */
  function openOrder(btn){
    var q=btn&&btn.dataset.forceQty?+btn.dataset.forceQty:qty;
    if(q!==qty)setQty(q);
    var comb=combo();
    var vk=q===6?'v6':'v';
    window.__comedor_SEL={qty:q,producto:TIER[q].prod,color:sel[vk],diseno:sel.k,puerta:dByK(puertaKey()).p,juegos:comb.map(function(k){return dByK(k)[vk]}),disenos:comb};
    try{localStorage.setItem('te_regalo','comedor|'+Date.now())}catch(e){}
    if(rsiCOD(window.__comedor_SEL))return;                                    // tienda: Releasit en la landing
    if(window.comedorTriggerCOD&&window.comedorTriggerCOD()!==false)return;   // respaldo de la fábrica
    abrirModalLocal();                                                         // vista previa local
  }
  function findVar(prod,t){t=String(t).toUpperCase();return (prod.variants||[]).filter(function(v){return String(v.title).toUpperCase()===t||String(v.option1).toUpperCase()===t})[0]}
  function espera(ms){return new Promise(function(r){setTimeout(r,ms)})}
  function avisoCargando(on){
    var t=document.getElementById('cd-wait');
    if(!t){t=document.createElement('div');t.id='cd-wait';t.textContent='🎄 Preparando tu pedido…';
      t.style.cssText='position:fixed;left:50%;bottom:140px;transform:translateX(-50%);z-index:2147483000;background:#7A0C16;color:#fff;font:700 15px/1.2 "DM Sans",sans-serif;padding:13px 20px;border-radius:999px;box-shadow:0 6px 24px rgba(0,0,0,.25);transition:opacity .3s;pointer-events:none';
      document.body.appendChild(t)}
    t.style.opacity=on?'1':'0';
  }
  function errorPedido(){
    avisoCargando(false);
    $('#cd-modal-body').innerHTML='<p style="padding:8px 0">No pudimos preparar tu pedido en este momento. Revisa tu conexión e inténtalo de nuevo.</p>';
    $('#cd-modal').classList.add('show');
  }
  async function listoReleasit(){
    for(var i=0;i<80;i++){
      try{var R=window._rsiV2,st=R&&R.getState&&R.getState();
        if(R&&R.cartService&&st&&st.loadingState&&!st.loadingState.isLoading)return R}catch(e){}
      await espera(100);
    }
    throw new Error('Releasit no cargó');
  }
  /* ---- PUERTA "GRATIS" EN EL FORMULARIO (pedido de Danny 2026-10-13) ----
     Shopify reparte el descuento del combo entre las 2 líneas, así que Releasit mostraba la puerta a ~$54.074.
     Aquí solo se cambia LO QUE SE VE: puerta → "GRATIS 🎁 REGALO" y sillas → el total del combo. El pedido,
     el subtotal, los descuentos y el total siguen siendo los reales de Shopify (cuadran: 259.800 + 79.900 − 109.800).
     Solo se maquilla si lo que se cobra no pasa del precio de lista de las sillas solas (si el descuento no
     aplicó, se ve el precio real). Releasit es React: se edita el valor del nodo de texto (no se reemplaza)
     y un observador lo re-aplica cuando Releasit re-pinta. ---- */
  var MAQ=null,maqObs=null,maqEl=null,maqTn=new WeakMap();
  var MAQ_CSS='#rsi_form_wrapper [data-cd-gratis]{order:2}'+
    '#rsi_form_wrapper [data-cd-gratis] .rsi-product-item-final-price{color:#0B7A3B!important;font-weight:800!important;letter-spacing:.04em}'+
    '#rsi_form_wrapper [data-cd-gratis] .rsi-product-item-remove{display:none!important}'+
    '#rsi_form_wrapper [data-cd-sinorig] .rsi-product-item-original-price{display:none!important}'+
    '#cd-rsi-regalos{margin:10px 0 4px;padding:10px 12px;border:2px dashed #B3121F;border-radius:10px;background:#FFF7EC;color:#3a1a14;line-height:1.3}'+
    '#cd-rsi-regalos .t{font-weight:800;font-size:14px;color:#7A0C16;margin:0 0 6px}'+
    '#cd-rsi-regalos .r{display:flex;align-items:center;gap:8px;font-size:13px;margin:5px 0}'+
    '#cd-rsi-regalos img{width:30px;height:30px;border-radius:6px;object-fit:cover;object-position:top;flex:0 0 auto;background:#fff}'+
    '#cd-rsi-regalos .r span{flex:1}#cd-rsi-regalos s{color:#9b8e86;font-size:12px}'+
    '#cd-rsi-regalos b{color:#0B7A3B;font-size:12px;font-weight:800;letter-spacing:.04em}'+
    '#cd-rsi-regalos .n{font-size:11.5px;color:#7a6a62;margin:6px 0 0}'+
    '#rsi_form_wrapper .rsi-product-item-prices span{white-space:nowrap}'+   // que "$389.700,00" no se parta
    '#rsi_form_wrapper [data-cd-gratis] .rsi-product-item-name:after{content:"🎁 REGALO";display:inline-block;margin-left:6px;padding:2px 8px;border-radius:999px;background:#B3121F;color:#fff;font-size:11px;font-weight:800;line-height:1.5;vertical-align:middle;white-space:nowrap}'+
    // el botón de comprar del formulario, igual al .cd-cta de la landing (Releasit lo pinta verde con !important a nivel de clase)
    '#rsi_form_wrapper .rsi-submit_button{background:linear-gradient(180deg,#d01b2a,#B3121F 60%,#930d18)!important;border:0!important;border-radius:14px!important;box-shadow:0 10px 24px rgba(179,18,31,.35),inset 0 1px 0 rgba(255,255,255,.25)!important;color:#fff!important}'+
    '#rsi_form_wrapper .rsi-submit_button .rsi-custom-button-content{font-weight:800!important;letter-spacing:.02em}'+
    '#rsi_form_wrapper .rsi-submit_button:hover{filter:brightness(1.07)}';
  function precioNum(t){return parseFloat(String(t||'').replace(/[^\d,]/g,'').replace(',','.'))||0}
  function precioTxt(n){var p=n.toFixed(2).split('.');return '$'+p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+p[1]}
  function txtNodo(el){var tn=el&&el.firstChild;return tn&&tn.nodeType===3?tn:null}
  function valorReal(el){var tn=txtNodo(el);if(!tn)return '';var st=maqTn.get(tn);return st&&tn.nodeValue===st.mio?st.orig:tn.nodeValue}
  function ponTxt(el,v){var tn=txtNodo(el);if(!tn)return;var st=maqTn.get(tn);
    if(!st||tn.nodeValue!==st.mio){st={orig:tn.nodeValue};maqTn.set(tn,st)}   // lo último que escribió Releasit
    st.mio=v;if(tn.nodeValue!==v)tn.nodeValue=v}
  function quitaTxt(el){var tn=txtNodo(el),st=tn&&maqTn.get(tn);if(st&&tn.nodeValue===st.mio)tn.nodeValue=st.orig;if(tn)maqTn.delete(tn)}
  function maquillar(){
    var f=document.getElementById('rsi_form_wrapper');if(!f)return;
    var w=[].slice.call(f.querySelectorAll('.rsi-product-item-wrapper')),d=null,sl=[],ok=false;
    if(MAQ)w.forEach(function(x){var n=((x.querySelector('.rsi-product-item-name')||{}).textContent||'').trim();
      if(MAQ.puerta&&n===MAQ.puerta)d=x;else if(n===MAQ.sillas)sl.push(x)});   // con diseños mezclados hay varias líneas de sillas
    regalosForm(sl[0]||null);
    if(d&&sl.length){
      var q=function(x){return +((x.querySelector('.rsi-product-item-quantity')||{}).textContent||0)};
      var dF=d.querySelector('.rsi-product-item-final-price'),fin=[],sumC=0,sumO=0,qc=0,completo=!!dF;
      sl.forEach(function(x){var fe=x.querySelector('.rsi-product-item-final-price'),oe=x.querySelector('.rsi-product-item-original-price');
        fin.push(fe);qc+=q(x);if(!fe||!oe){completo=false;return}sumC+=precioNum(valorReal(fe));sumO+=precioNum(oe.textContent)});
      var dv=completo?precioNum(valorReal(dF)):0, total=sumC+dv;
      ok=completo&&q(d)===1&&qc>=1&&sumC>0&&total<=Math.max(sumO,MAQ.precio||0)+0.5;   // lo cobrado no pasa de lo prometido por las sillas solas (si el descuento no aplicó, se ve el precio real)
    }
    if(ok){
      if(!d.hasAttribute('data-cd-gratis'))d.setAttribute('data-cd-gratis','');ponTxt(dF,'GRATIS');
      // el valor repartido de la puerta se suma a los juegos (proporcional, en pesos enteros); el último se lleva el residuo para que cuadre exacto
      var acum=0;sl.forEach(function(x,i){var v=precioNum(valorReal(fin[i])),nv=i<sl.length-1?Math.round(v+dv*v/sumC):Math.round(total-acum);acum+=nv;ponTxt(fin[i],precioTxt(nv));
        // en 4 + puerta las sillas quedan por encima de su precio de lista (129.900 → 149.900): no se muestra un tachado más bajo que el precio
        var oe=x.querySelector('.rsi-product-item-original-price');if(oe&&precioNum(oe.textContent)<=nv+0.5)x.setAttribute('data-cd-sinorig','');else x.removeAttribute('data-cd-sinorig')});
      return;
    }
    w.forEach(function(x){if(x.hasAttribute('data-cd-gratis'))x.removeAttribute('data-cd-gratis');if(x.hasAttribute('data-cd-sinorig'))x.removeAttribute('data-cd-sinorig');quitaTxt(x.querySelector('.rsi-product-item-final-price'))});
  }
  // las 3 guías PDF también se ven en el formulario (la puerta ya sale como línea GRATIS en 4, 6 y 8)
  function regalosForm(c){
    var box=document.getElementById('cd-rsi-regalos'),anc=c&&c.closest('.rsi-product-details-wrapper');
    if(!anc){if(box)box.remove();return}
    var k=MAQ&&MAQ.puerta?'p':'s';
    if(!box){box=document.createElement('div');box.id='cd-rsi-regalos'}
    if(box.getAttribute('data-k')!==k){box.setAttribute('data-k',k);
      box.innerHTML='<p class="t">🎁 '+(k==='p'?'Y además te llevas GRATIS':'Con tu pedido te llevas GRATIS')+'</p>'+
        [[__A('ad-assets/regalo-mesa-del-24.svg'),'Guía "La Mesa del 24"','$29.900'],[__A('ad-assets/regalo-novena.svg'),'Novena de Aguinaldos para imprimir','$19.900'],[__A('ad-assets/regalo-cuidado.svg'),'Guía "Que dure muchas Navidades"','$19.900']]
        .map(function(x){return '<div class="r"><img src="'+x[0]+'" alt=""><span>'+x[1]+'</span><s>'+x[2]+'</s><b>GRATIS</b></div>'}).join('')+
        '<p class="n">📩 Las guías se descargan apenas confirmes tu pedido.</p>'}
    if(box.parentNode!==anc.parentNode||box.previousElementSibling!==anc)anc.parentNode.insertBefore(box,anc.nextSibling);
  }
  function vigilarForm(){
    if(!document.getElementById('cd-maq-css')){var c=document.createElement('style');c.id='cd-maq-css';c.textContent=MAQ_CSS;document.head.appendChild(c)}
    var t0=Date.now();
    (function busca(){
      var f=document.getElementById('rsi_form_wrapper');
      if(f&&f!==maqEl){if(maqObs)maqObs.disconnect();maqEl=f;var pend=0;
        maqObs=new MutationObserver(function(){if(!pend){pend=1;setTimeout(function(){pend=0;maquillar()},16)}});
        maqObs.observe(f,{childList:true,subtree:true,characterData:true})}
      maquillar();
      if(!f&&Date.now()-t0<6000)setTimeout(busca,150);
    })();
  }
  function rsiCOD(s){
    var C=shopCfg();
    var hp=C[s.producto||'sillas'];
    if(!(window.Shopify&&hp&&C.puerta))return false;
    avisoCargando(true);
    (async function(){
      var j=function(u){return fetch(u,{headers:{Accept:'application/json'}}).then(function(r){return r.json()})};
      var pp=await Promise.all([j('/products/'+hp+'.js'),s.puerta?j('/products/'+C.puerta+'.js'):null]);
      var gid=function(v){return 'gid://shopify/ProductVariant/'+v.id};
      // un juego por cada diseño elegido (en 8 se pueden mezclar); los diseños repetidos van en una sola línea con su cantidad
      var lines=[],idx={},falta=false;
      for(var x=0;x<nJ(s.qty);x++){var vj=findVar(pp[0],(s.juegos&&s.juegos[x])||s.color);
        if(!vj){falta=true;break}var m=gid(vj);
        if(m in idx)lines[idx[m]].quantity++;else{idx[m]=lines.length;lines.push({merchandiseId:m,quantity:1})}}
      var b=s.puerta?findVar(pp[1],s.puerta):null;
      if(falta||(s.puerta&&!b))throw new Error('variante no encontrada');
      MAQ={sillas:String(pp[0].title).trim(),puerta:b?String(pp[1].title).trim():null,precio:P[s.qty]};   // precio = lo prometido en la landing   // qué líneas maquillar / dónde poner los regalos
      if(b)lines.push({merchandiseId:gid(b),quantity:1});
      var R=await listoReleasit(), cs=R.cartService;
      R.setState({isOpen:false});
      var st=R.getState(), S=window._RSI_COD_FORM_SETTINGS;
      // 'producto + carrito' SOLO en esta página y en esta visita (Releasit re-lee el modo de su config al abrir;
      // en 'product-only' agrega además el diseño por defecto de la página)
      if(S&&S.productPage)S.productPage.addMode='product-plus-cart';
      R.setState({productPage:Object.assign({},st.productPage,{addMode:'product-plus-cart'})});
      var id=st.cartInfo&&st.cartInfo.id;
      if(!id){var g0=await cs.getCart();id=g0.data.cart.id;R.setState({cartInfo:g0.data.cart})}
      await cs.clearCart(id);
      await cs.addProduct(id,lines);
      R.setState({isOpen:true});
      R.setState({triggerCartUpdate:1});
      vigilarForm();
      // verificación + autocorrección: el carrito de Releasit debe quedar con EXACTAMENTE estas líneas
      var want={};lines.forEach(function(l){want[l.merchandiseId]=l.quantity});
      var ok=false;
      for(var k=0;k<4&&!ok;k++){
        await espera(k?700:1200);
        var cid=R.getState().cartInfo.id, g=await cs.getCart(cid), edges=g.data.cart.lines.edges||[];
        var sobran=[], corregir=[], vistos={};
        edges.forEach(function(e){var m=e.node.merchandise.id;
          if(!(m in want)||vistos[m])sobran.push(e.node.id);
          else{vistos[m]=1;if(e.node.quantity!==want[m])corregir.push({id:e.node.id,quantity:want[m]})}});
        var faltan=lines.filter(function(l){return !vistos[l.merchandiseId]});
        ok=!sobran.length&&!corregir.length&&!faltan.length;
        if(!ok){
          if(sobran.length)await cs.removeProduct(cid,sobran);
          if(corregir.length)await cs.updateProduct(cid,corregir);
          if(faltan.length)await cs.addProduct(cid,faltan);
          R.setState({triggerCartUpdate:1});
        }
      }
      if(!ok){R.setState({isOpen:false});throw new Error('el carrito de Releasit no cuadró tras corregir')}
      avisoCargando(false);
    })().catch(function(e){
      console.warn('[comedor] pedido:',e);
      avisoCargando(false);
      if(!s.puerta&&window.comedorTriggerCOD&&window.comedorTriggerCOD()!==false)return;   // 4 sillas: flujo normal de Releasit
      errorPedido();                                                                          // sin la puerta no se cobra
    });
    return true;
  }
  function abrirModalLocal(){
    var s=window.__comedor_SEL, n=s.qty;
    var dk=s.disenos||[sel.k], disenos=dk.map(function(k,i){return (dk.length>1?'Juego '+(i+1)+': ':'')+dByK(k).n}).join('<br>');
    var rows=[['Diseño'+(dk.length>1?'s':''),disenos],['Fundas',n+' sillas ('+(n===8?'2 juegos de 4':'1 juego de '+n)+')'],['Funda de puerta gemela',s.puerta?'🎁 GRATIS · '+dByK(puertaKey()).n:'— (desde 8 sillas)'],['3 guías PDF (Mesa del 24, Novena, Cuidado)','🎁 GRATIS'],['Total a pagar al recibir','<b style="color:#B3121F">'+fmt(P[s.qty])+'</b>']];
    $('#cd-modal-body').innerHTML=rows.map(function(r){return '<div class="cd-modal-row"><span>'+r[0]+'</span><span>'+r[1]+'</span></div>'}).join('');
    $('#cd-modal').classList.add('show');
  }
  $$('[data-order]').forEach(function(b){b.addEventListener('click',function(){openOrder(b)})});
  $$('[data-close]').forEach(function(b){b.onclick=function(){$('#cd-modal').classList.remove('show')}});
  $('#cd-modal').addEventListener('click',function(e){if(e.target.id==='cd-modal')e.currentTarget.classList.remove('show')});

  /* sticky */
  // pedido de Danny (2026-10-13): que la clienta NUNCA pierda de vista el botón de comprar. La barra se ve desde que
  // abre la página (celular y computador) y solo se esconde mientras un botón grande de compra ya está en pantalla.
  var sticky=$('#cd-sticky'), grandes=$$('.cd-cta[data-order]').filter(function(b){return !sticky.contains(b)}), enVista=[];
  function stickyOn(){sticky.classList.toggle('show',enVista.indexOf(true)<0)}
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){enVista[grandes.indexOf(e.target)]=e.isIntersecting});stickyOn()},{threshold:.6});
    grandes.forEach(function(b){io.observe(b)});
  }
  stickyOn();
  $('#cd-st-gifts').onclick=function(){var g=$('.cd-gifts');if(g)g.scrollIntoView({behavior:'smooth',block:'center'})};

  /* countdown real (temporada o fecha límite del 24) */
  var target=esDic?LIMITE_24:TEMPORADA_FIN;
  function tick(){
    var ms=target.getTime()-Date.now();
    if(ms<=0){$('#cd-count').style.display='none';return}
    var d=Math.floor(ms/864e5),h=Math.floor(ms%864e5/36e5),m=Math.floor(ms%36e5/6e4);
    $('#cd-d').textContent=d;$('#cd-h').textContent=('0'+h).slice(-2);$('#cd-m').textContent=('0'+m).slice(-2);
  }
  tick();setInterval(tick,30000);

  /* antes / después */
  var rg=$('#cd-ba-range');
  if(rg){rg.addEventListener('input',function(){var v=rg.value;$('#cd-ba-after').style.clipPath='inset(0 0 0 '+v+'%)';$('#cd-ba-line').style.left=v+'%'})}

  /* nieve */
  var cv=$('#cd-snow');
  if(cv&&!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)){
    var cx=cv.getContext('2d'),W,H,F=[],dpr=Math.min(window.devicePixelRatio||1,2),run=true;
    function size(){W=cv.width=innerWidth*dpr;H=cv.height=innerHeight*dpr}
    size();addEventListener('resize',size);
    var N=innerWidth<768?14:24;   // versión sobria: pocos copos
    for(var i=0;i<N;i++)F.push({x:Math.random()*W,y:Math.random()*H,r:(Math.random()*2.2+1)*dpr,s:(Math.random()*.6+.35)*dpr,w:Math.random()*6.28,o:Math.random()*.3+.3});
    function draw(){
      if(!run)return;
      cx.clearRect(0,0,W,H);
      for(var i=0;i<F.length;i++){var f=F[i];f.y+=f.s;f.w+=.012;f.x+=Math.sin(f.w)*.35*dpr;
        if(f.y>H+10){f.y=-10;f.x=Math.random()*W}
        cx.beginPath();cx.arc(f.x,f.y,f.r,0,6.283);cx.fillStyle='rgba(255,255,255,'+f.o+')';cx.shadowBlur=0;cx.fill()}
      requestAnimationFrame(draw);
    }
    document.addEventListener('visibilitychange',function(){run=!document.hidden;if(run)requestAnimationFrame(draw)});
    requestAnimationFrame(draw);
  }

  /* calculadora ¿Le queda? */
  var arms=0;
  $$('[data-arms]').forEach(function(b){b.onclick=function(){arms=+b.dataset.arms;$$('[data-arms]').forEach(function(x){x.classList.toggle('on',x===b)});calc()}});
  function calc(){
    var al=parseFloat($('#cd-in-alto').value),an=parseFloat($('#cd-in-ancho').value),fo=parseFloat($('#cd-in-fondo').value),r=$('#cd-calc-res');
    r.className='cd-calc-res';
    if(arms){r.classList.add('no');r.innerHTML='❌ <b>Con brazos no entra.</b> Esta funda es para sillas de comedor sin brazos.';return}
    if(!(al>0&&an>0&&fo>0)){r.textContent='Escribe las 3 medidas y te decimos al instante.';return}
    var big=al>67||an>52||fo>52, small=al<43||an<38||fo<38;
    var edge=(al>65&&al<=67)||(al<45&&al>=43)||(an>50&&an<=52)||(an<40&&an>=38)||(fo>50&&fo<=52)||(fo<40&&fo>=38);
    if(big){r.classList.add('no');r.innerHTML='❌ <b>Tu silla es más grande que la funda</b> (respaldo hasta 65 cm y asiento hasta 50 cm). No te la recomendamos.'}
    else if(small){r.classList.add('no');r.innerHTML='❌ <b>Tu silla es más pequeña que la funda:</b> le quedaría holgada. No te la recomendamos.'}
    else if(edge){r.classList.add('warn');r.innerHTML='⚠️ <b>Al límite.</b> El elástico da un poco y probablemente le quede, pero puede quedar justa u holgada.'}
    else{r.classList.add('ok');r.innerHTML='✅ <b>¡Le queda!</b> Tu silla está dentro de las medidas. Y si aun así no le queda, te la cambiamos con la Garantía Mesa Lista.'}
  }
  ['#cd-in-alto','#cd-in-ancho','#cd-in-fondo'].forEach(function(id){$(id).addEventListener('input',calc)});

  /* muro de ideas: dos filas que se mueven en sentidos opuestos */
  var W1=[['02-lifestyle','Papá y Mamá Noel · la cena del 24'],['06-cocina','Copo de Nieve · el desayuno del 25'],['13-mesa-angel','Ángel · mesa blanca y dorada'],['07-negocio','Merry Christmas · tu café o negocio'],['16-foto-familia','Chimenea · la foto del 24'],['05-puerta-mesa','Bienvenido · de la puerta a la mesa']];
  var W2=[['08-novena','Pesebre · la novena en casa'],['11-ninos','Bambi · el comedor de los niños'],['12-gato','Copo de Nieve · a prueba de gato'],['15-merry-moderno','Merry Christmas · apartamento moderno'],['04-despues','Bienvenido · el mismo comedor, otra noche'],['09-detalle','Ángel · la tela de cerca'],['01-hero','Chimenea · comedor de 6']];
  function row(list,rev){
    var r=document.createElement('div');r.className='cd-row'+(rev?' rev':'');
    list.concat(list).forEach(function(it){
      var t=document.createElement('div');t.className='cd-tile';
      t.innerHTML='<img src="'+A('ad-assets/'+it[0]+'.jpg')+'" alt="'+it[1]+'" loading="lazy"><span>'+it[1]+'</span>';
      t.querySelector('img').onerror=function(){t.remove()};
      r.appendChild(t);
    });
    return r;
  }
  var wall=$('#cd-wall');if(wall){wall.appendChild(row(W1,false));wall.appendChild(row(W2,true))}

  setQty(8);pick('chimenea');
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__comedor_SEL || {};
    var V = window.COMEDOR_VARIANTS || [];
    var n = function (x) { return String(x || '').toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); };
    var v = V.filter(function (x) {
      return n(x.color) === n(s.color) && (s.size == null || String(x.talla) === String(s.size));
    })[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__comedor-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.comedorTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
